// extracted by mini-css-extract-plugin
module.exports = {"fileBtn":"GuidelinesSlugPage_fileBtn__1AtPQ","hr":"GuidelinesSlugPage_hr__2gmPe"};